<template>
  <!--新增普通模板-->
  <div>
    <div class="com-Breadcrumb">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item
          ><a @click="gback()">模板管理</a></el-breadcrumb-item
        >
        <el-breadcrumb-item>新增模板</el-breadcrumb-item>
      </el-breadcrumb>
      <a class="r-btn" @click="gback()">返回上一步</a>
    </div>
    <el-container class="general">
      <el-main class="main" v-loading="loadingTpl">
        <tpl-editor
          ref="tplEditor"
          @editorReadyCallback="handleEditorReadyCallback"
          @change="handleChange"
          @doubleclickPlaceholder="handeDoubleclickPlaceholder"
          @clickPlaceholder="handleClickPlaceholder"
          :insert-html="innerString"
          :change-placeholder="valChange"
          :del-placeholder="delInner"
          :select-placeholder="currentOpVar.varName || ''"
        />
      </el-main>

      <el-aside width="260px" class="aside">
        <h4>模板信息</h4>
        <el-form
          :model="tplFrm"
          ref="tplFrm"
          :rules="tplFrmRules"
          size="small"
          class="tpl-info"
        >
          <el-form-item label="模板名称" prop="tplName">
            <el-input
              v-model="tplFrm.tplName"
              placeholder="模板名称"
              maxlength="30"
            />
          </el-form-item>
          <el-form-item>
            使用范围：
            <el-button
              @click="setCheckedNodes()"
              size="mini"
              style="width: 80px;margin-left: 18px;"
              >选择 ></el-button
            >
            <ul class="checkedNode">
              <li v-for="item in defaultChooseList" :key="item.corpUserId">
                <a class="span1" :title="item.userName">{{
                  item.userName
                }}</a>
                <span class="span2" @click="deleteSelect(item.corpUserId)"
                  >x</span
                >
              </li>
            </ul>
          </el-form-item>
          <el-form-item>
            <el-button @click="toShowEditTplVarDialog(false)" class="btn"
              >添加变量</el-button
            >
          </el-form-item>
          <draggable
            :list="tplVarList"
            @start="dragging = true"
            @end="dragging = false"
          >
            <template v-if="tplVarList.length" v-for="(item, i) in tplVarList">
              <div :key="i" class="val-item">
                <p
                  @click="selectCurrentOpVar(item.varName)"
                  @dblclick="toShowEditTplVarDialog(true)"
                  :key="i"
                  :class="currentOpVar.varName == item.varName ? 'active' : ''"
                >
                  {{ item.varName }}
                  <i
                    @click="delTplVar(item)"
                    class="el-icon-circle-close del"
                  ></i>
                </p>
              </div>
            </template>
          </draggable>
        </el-form>
      </el-aside>
      <div class="bottom-field">
        <div style="height: 100%;width: 1020px;margin: 0 auto;">
          <el-button size="mini" @click="gback">取消</el-button>
          <el-button size="mini" @click="tplFrmSubmit" type="primary"
            >保存</el-button
          >
        </div>
      </div>

      <el-dialog
        :title="editTplVarDialogName"
        :visible.sync="showEditTplVarDialog"
        width="25%"
      >
        <el-form
          :model="tplVarFrm"
          ref="tplVarFrm"
          :rules="tplVarFrmRules"
          class="val-form"
          size="small"
        >
          <el-form-item label="变量名称" prop="varName">
            <el-input v-model="tplVarFrm.varName" />
          </el-form-item>
          <el-form-item label="变量类型">
            <el-select v-model="tplVarFrm.varType" class="select">
              <el-option label="文本" :value="0" />
              <el-option label="数字" :value="1" />
              <el-option label="日期" :value="2" />
              <el-option label="手机号码" :value="3" />
              <el-option label="身份证号码" :value="4" />
              <el-option label="营业执照号" :value="5" />
              <el-option label="统一社会编码格式" :value="6" />
              <el-option label="电子邮箱" :value="7" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="tplVarFrm.varIsMust" label="是否必填" />
          </el-form-item>
          <el-form-item class="text-right">
            <el-button @click="showEditTplVarDialog = false" size="mini"
              >取消</el-button
            >
            <el-button @click="editTplVarSubmit" type="danger" size="mini"
              >确定</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog
        title="选择授权范围"
        :visible.sync="visibleMoveOrg"
        top="5vh"
        width="50%"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <!-- table -->
            <section>
              <el-form
                style="margin-top: 20px;text-align:right"
                :inline="true"
                size="small"
                :model="filterModel"
              >
                <el-form-item label="">
                  <el-input
                    style="width: 150px;"
                    v-model="filterModel.targetId"
                    placeholder="邮箱/手机号"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    style="width: 150px;"
                    v-model="filterModel.corpUserName"
                    placeholder="签署方名称"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-select
                    v-model="filterModel.corpGroupId"
                    placeholder="请选择部门"
                    style="width: 150px;"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="(item, i) in memberGroups"
                      :key="i"
                      :label="item.groupName"
                      :value="item.corpGroupId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item style="margin-right:0px">
                  <el-button @click="queryTool">查询</el-button>
                  <el-button @click="approvalReset">重置</el-button>
                </el-form-item>
              </el-form>
              <!-- table -->
              <el-col :span="24" class="custom-table-style" style="padding: 0px">
                <el-table
                  ref="multipleTableRef"
                  @selection-change="handleSelectionChange0"
                  :data="tableSetManager"
                  style="border: 1px solid #cbcbcb; border-bottom: 0;"
                  tooltip-effect="dark"
                  highlight-current-row
                  :cell-style="{ cursor: 'pointer' }"
                  :header-cell-style="{
                  background: '#f9f9f9',
                  color: '#333333',
                  fontWeight: '500'
                }"
                >
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    label="邮箱/手机号"
                    prop="targetId"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    label="名称"
                    prop="userName"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    label="部门"
                    prop="groupNames"
                    show-overflow-tooltip
                  ></el-table-column>
                </el-table>
              </el-col>
              <!-- pagination -->
              <el-col :span="24" style="padding: 30px 0;position: relative;" class="page-flex-end">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="filterModel.itemPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="filterModel.pageSize"
                  layout="sizes, prev, pager, next, total"
                  :total="filterModel.pageTotal"
                />
                <el-go
                  :page-size="filterModel.pageSize"
                  :total="filterModel.pageTotal"
                  @current-change="handleCurrentChange"
                ></el-go>
              </el-col>
            </section>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="visibleMoveOrg = false">取 消</el-button>
          <el-button
            size="mini"
            type="primary"
            @click="handleSelectApprovalorOk()"
          >确 定</el-button>
        </span>
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
import draggable from "vuedraggable";
// import TplEditor from "../../components/tpl-editor";
import TplEditor from "../../components/tpl-editor";
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import ElGo from "../../components/go/Go";
export default {
  name: "authEdit",
  components: { draggable, TplEditor, ElGo },
  layout: "entconsolelayout",
  data() {
    return {
      // filter model
      filterModel: {
        targetId: "",
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        corpGroupId: ""
      },
      tableSetManager: [],
      memberGroups: [],
      selectApprovalorTableRow: [],
      selectApprovalorManagerValue: 1,
      corpUserIdSet: '',
      defaultChooseList: [],

      moveDeptSelect: [],
      departmentArray: [],
      defaultProps: {
        children: "childCorpGroups",
        label: "label"
      },
      treeGroupCopy: [],
      tplFrm: { tplId: "", tplName: "", serialNum: "" },
      visibleMoveOrg: false,
      tplFrmRules: {
        tplName: [
          { validator: this.$validator.required, message: "模板名称不能为空" },
          {
            validator: this.$validator.regex,
            regex: /^(?![\s])(?!.*[\s]$).*$/,
            trigger: "change",
            message: "变量名称前后不要留空白"
          },
          {
            validator: this.$validator.lengthRank,
            minLength: 2,
            maxLength: 30,
            trigger: "change"
          }
        ]
      },
      editTplVarDialogName: "新增模板变量",
      tplVarList: [],
      showEditTplVarDialog: false,
      currentOpVar: {},
      tplVarFrm: { varName: "", varType: 0, varIsMust: false },
      varTypeEnum: [
        {
          label: ""
        }
      ],
      tplVarFrmRules: {
        varName: [
          {
            validator: this.$validator.required,
            trigger: "change",
            message: "变量名称不能为空"
          },
          {
            validator: this.$validator.regex,
            regex: /^(?![\s])(?!.*[\s]$).*$/,
            trigger: "change",
            message: "变量名称前后不要留空白"
          },
          {
            validator: this.$validator.lengthRank,
            minLength: 2,
            maxLength: 30,
            trigger: "change"
          },
          {
            validator: (rule, val, callback) => {
              for (var key in this.tplVarList) {
                if (
                  this.tplVarList[key].varName == val &&
                  this.currentOpVar.varName != val
                ) {
                  return callback("变量名称不能重复");
                }
              }
              callback();
            },
            trigger: "change"
          }
        ]
      },
      valChange: { name: "", oldName: "" },
      innerString: null,
      delInner: "",
      dragging: false,
      loadingTpl: false
    };
  },
  mounted() {
    this.initTreeGroup();
    this.queryTool();
    setTimeout(() => this.$refs.tplFrm.resetFields());
  },
  methods: {
    // 重置
    approvalReset(){
      this.filterModel= {
        targetId: "",
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
        corpGroupId: ""
      }
      this.queryTool()
    },
    //选择项确定
    handleSelectApprovalorOk() {
      let arr = this.selectApprovalorTableRow.map(item => {
        return item.corpUserId;
      });
      this.defaultChooseList = this.selectApprovalorTableRow;
      this.corpUserIdSet = arr.join(',') || '';
      this.visibleMoveOrg = false;
    },
    // 分页事件
    handleSizeChange(val) {
      this.filterModel.itemPage = 1;
      this.filterModel.pageSize = val;
      this.queryTool();
    },
    handleCurrentChange(val) {
      this.filterModel.itemPage = val;
      this.queryTool();
    },
    handleSelectionChange0(row) {
      this.selectApprovalorTableRow = row;
    },
    // query member table data  //获取人员列表
    queryTool() {
      this.selectApprovalorTableRow = [];
      ApiCorpMethods.OrganizationController.listCorpUsers({
        ...this.filterModel,
        permId: 6,
      })
        .then(res => {
          if (res.code === "0") {
            this.tableSetManager = res.data;
            this.filterModel.pageTotal = res.total;
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
    getMemberGroups(data) {
      data.forEach(i => {
        this.memberGroups.push(i);
        if ((i.childCorpGroups || []).length > 0)
          this.getMemberGroups(i.childCorpGroups);
      });
    },
    gback() {
      // this.$router.push({ path: "/console/setting?activeName=tab-template" });
      this.$router.push({
        path: "/console/template",
        query: { activeName: "mianSign" }
      });
    },
    initTreeGroup() {
      let params = {};
      params.permId = 6;
      ApiCorpMethods.OrganizationController.treeGroup(params)
        .then(res => {
          if (+res.code === 0) {
            this.treeGroup = this.convertFormateTree(res.data);
            this.treeGroupCopy = JSON.parse(JSON.stringify(this.treeGroup));
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message({ type: "error", message: error.description });
        });
    },
    // 转换成tree需要的数据格式
    convertFormateTree(data) {
      data.forEach(element => {
        this.departmentArray.push(element);
        element.label = element.groupName + "(" + element.totalNum + "人)";
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups);
        }
      });
      return data;
    },
    recursionChildren(childCorpGroups) {
      childCorpGroups.forEach(element => {
        this.departmentArray.push(element);
        element.label = element.groupName + "(" + element.totalNum + "人)";
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups);
        }
      });
    },
    getCheckedNodes() {
      this.visibleMoveOrg = false;
    },

    setCheckedNodes() {
      this.visibleMoveOrg = true;
    },
    deleteSelect(corpUserId) {
      this.defaultChooseList = this.defaultChooseList.filter((item) => {
        return item.corpUserId !== corpUserId;
      })
      let arr = this.defaultChooseList.map(item => {
        return item.corpUserId;
      });
      this.corpUserIdSet = arr.join(',') || '';
      // this.moveDeptSelect = this.moveDeptSelect.filter(
      //   i => i.corpGroupId !== corpGroupId
      // );
    },
    handleEditorReadyCallback: function() {
      this.tplFrm.tplId = this.$route.query.tplId;
      if (this.tplFrm.tplId) {
        this.loadTpl(this.tplFrm.tplId);
      }
    },
    loadTpl: function(tplId) {
      this.loadingTpl = true;
      ApiMethods.TemplateController.cmListTplDetail({ tplId: tplId })
        .then(result => {
          if (result.success) {
            this.tplFrm = result.data;
            this.moveDeptSelect = this.tplFrm.groupList;
            this.tplVarList = result.data.varList;
            this.$refs.tplEditor.setData(this.tplFrm.context);
          } else {
            this.$message.error(result.description || this.$tip);
          }
        })
        .finally(() => {
          this.loadingTpl = false;
        });
    },
    // 选择变量
    selectCurrentOpVar: function(name) {
      if (name) {
        this.currentOpVar = {};
        this.tplVarList.forEach(t => {
          if (t.varName === name) {
            return (this.currentOpVar = JSON.parse(JSON.stringify(t)));
          }
        });
      } else {
        this.currentOpVar = {};
      }
    },
    // placeholder 单击选中列表中的某个值
    handleClickPlaceholder: function(name) {
      if (!name || name === "") {
        this.currentOpVar = {};
      } else {
        this.selectCurrentOpVar(name);
      }
    },
    // placeholder 双击修改变量
    handeDoubleclickPlaceholder: function(name) {
      this.selectCurrentOpVar(name);
      this.toShowEditTplVarDialog(true);
    },
    // 编辑器内容变化处理
    handleChange: function(info) {
      this.tplFrm.context = info;
    },
    // 弹出变量表单
    toShowEditTplVarDialog: function(isUpd) {
      this.showEditTplVarDialog = true;
      if (isUpd) {
        this.tplVarFrm = JSON.parse(JSON.stringify(this.currentOpVar));
        this.editTplVarDialogName = "修改模板变量";
      } else {
        this.currentOpVar = {};
        this.tplVarFrm = { varName: "", varType: 0, varIsMust: false };
      }
      this.tplVarFrm.isUpd = isUpd;
    },
    editTplVarSubmit: function() {
      this.$refs.tplVarFrm.validate(valid => {
        if (valid) {
          if (this.tplVarFrm.isUpd) {
            //编辑
            //修改editor里面的值
            this.valChange = {
              name: this.tplVarFrm.varName,
              oldName: this.currentOpVar.varName
            };
            console.info(this.valChange);
            //修改变量列表的值
            for (var key in this.tplVarList) {
              if (this.tplVarList[key].varName === this.currentOpVar.varName) {
                this.tplVarList[key] = this.tplVarFrm;
                break;
              }
            }
          } else {
            //新加
            this.tplVarList.push(this.tplVarFrm);
            this.innerString = `[[${this.tplVarFrm.varName}]] `;
          }
          this.showEditTplVarDialog = false;
        }
      });
    },

    delTplVar: function(info) {
      this.tplVarList.forEach((t, i) => {
        if (t.varName === info.varName) {
          this.delInner = info.varName;
          return this.tplVarList.splice(i, 1);
        }
      });
    },

    tplFrmSubmit: function() {
      this.$refs.tplFrm.validate(valid => {
        if (valid) {
          var param = this.tplFrm;
          const contextHtml = this.$refs.tplEditor.editor.getData();
          this.tplFrm.context = contextHtml;
          const document = this.$refs.tplEditor.editor.document;
          if (document) {
            var contextText = document
              .getBody()
              .getText()
              .trim();
            if (!contextText || contextText.length < 1 || contextText === "") {
              return this.$alert("请填写模板内容", "系统提示");
            }
          }
          if (!contextHtml || contextHtml === "") {
            return this.$alert("模板内容不能为空", "系统提示");
          }

          this.$refs.tplEditor.selectAllVar(vars => {
            var varList = [];
            if (this.tplVarList && this.tplVarList.length > 0) {
              for (var i = 0; i < this.tplVarList.length; i++) {
                var o = this.tplVarList[i];
                if (vars.has(o.varName)) {
                  varList.push(o);
                }
              }
            }
            param.varList = JSON.stringify(varList);
            // param.groupIdSet = this.moveDeptSelect
            //   .map(i => i.corpGroupId)
            //   .join(",");
            param.corpUserIdSet = this.corpUserIdSet;
            ApiMethods.TemplateController.cmOperTpl(param).then(result => {
              console.log("保存成功，返回页面");
              if (result.success) {
                this.$alert("操作成功", "系统提示", {
                  confirmButtonText: "确定",
                  callback: action => {
                    // this.$router.push({path: '/console/setting?activeName=tab-template'});
                    this.$router.push({
                      path: "/console/template",
                      query: { activeName: "mianSign" }
                    });
                  }
                });
              } else {
                this.$message.error(result.description || this.$tip);
              }
            });
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.checkedNode {
  margin-top: 20px;

  li {
    float: left;
    width: 99px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    margin: 0 10px 10px 0;
    border-radius: 4px;
    overflow: hidden;

    .span1 {
      display: inline-block;
      width: 67px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      background: rgba(241, 241, 241, 1);
    }

    .span2 {
      display: inline-block;
      width: 29px;
      background: rgba(241, 241, 241, 1);
      cursor: pointer;
      vertical-align: top;
      margin-left: 2px;
    }
  }
}

.bottom-field {
  position: fixed;
  z-index: 2;
  width: 100%;
  left: 0;
  bottom: 0;
  box-sizing: content-box;
  line-height: 60px;
  padding-right: 30px;
  margin-left: -20px;
  background-color: #fff;
  text-align: right;
  box-shadow: 0 -3px 4px rgba(0, 0, 0, 0.1);

  .btns {
    vertical-align: middle;
    padding: 8px 25px;
  }
}

.general {
  padding: 20px 0;
  background: #fff;
  .main {
    padding: 0 20px 0 20px;
  }
}

.val-form {
  .select {
    width: 100%;
  }

  .btn {
    width: 100px;
  }
}

.aside {
  box-sizing: border-box;
  margin-right: 20px;
  display: table-cell;
  border: 1px solid #d7d7d7;

  .val-item {
    margin: 15px 0;
    clear: both;
    cursor: move;

    p {
      overflow: hidden;
      border-width: 1px 1px 1px 2px;
      border-style: dashed;
      border-color: #999999;
      line-height: 200%;
      padding-left: 10px;
      color: #999999;
    }

    .del {
      float: right;
      font-size: 18px;
      margin-top: 5px;
      margin-right: 5px;
      cursor: pointer;
    }

    p.active {
      border-color: #ec1c1c;
      color: #ec1c1c;
    }
  }

  .tpl-info {
    padding: 20px;

    .btn {
      width: 100%;
    }
  }

  h4 {
    font-size: 14px;
    color: #333333;
    font-weight: 500;
    line-height: 300%;
    background-color: #f2f2f2;
    text-align: center;
  }
}

/deep/ .cke_contents {
  height: calc(100vh - 370px) !important;
}
</style>



// WEBPACK FOOTER //
// pages/authEdit/authEditNew.vue